import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BookingcomOffer } from '@app/models/offerpack/BookingcomOffer';
import { Subject } from 'rxjs';

@Component({
    selector: 'clever-boolingcom-detail',
    templateUrl: './boolingcom-detail.component.html',
    styleUrls: ['./boolingcom-detail.component.scss'],
    standalone: false
})
export class BoolingcomDetailComponent implements OnInit, OnDestroy {
    @Input() datas: BookingcomOffer;
    @Output() sendReg: EventEmitter<boolean> = new EventEmitter();
    private unsubscribe$ = new Subject();

    deskMode: boolean = true;

    curentContent: number = 0;

    constructor(
        protected mediaObserver: BreakpointObserver,
    ) {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.deskMode = false;
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.deskMode = true;
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.deskMode = true;
        }
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    sendAnmeldung() {
        this.sendReg.emit(true);
    }
}
